import { render, staticRenderFns } from "./CouplesReadingEnForm.vue?vue&type=template&id=b99c2f08&scoped=true&lang=pug&"
import script from "./CouplesReadingEnForm.vue?vue&type=script&lang=js&"
export * from "./CouplesReadingEnForm.vue?vue&type=script&lang=js&"
import style0 from "./CouplesReadingEnForm.vue?vue&type=style&index=0&id=b99c2f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99c2f08",
  null
  
)

export default component.exports